import type { Option } from '@app-types/index';

import { i18nInstance } from '@/i18n/instance';
import { buildYesNoOptions } from '@/lib/builders/selectOptions';

/* Finance Selector Constants */
// Variable income options for the finance step
export const VARIABLE_INCOME_OPTIONS: Option[] = [
  { value: true, label: 'Sí', meta: 'tiene ingresos variables' },
  { value: false, label: 'No', meta: 'tiene ingresos variables' },
];

export const PROFESSION_OPTIONS = [
  { value: '0000', label: 'No Aplica' },
  {
    value: '0100',
    label: 'Miembros de las fuerzas armadas de otro país',
  },
  {
    value: '0200',
    label: 'Trabajadores en ocupaciones no identificables o no declaradas',
  },
  {
    value: '0300',
    label: 'Jubilado / pensionado / sin profesión',
  },
  {
    value: '1110',
    label: 'Miembros del poder ejecutivo y legislativo',
  },
  {
    value: '1120',
    label: 'Personal directivo de la administración pública',
  },
  {
    value: '1130',
    label: 'Miembros de los gobiernos locales y jefes de pequeñas poblaciones',
  },
  {
    value: '1140',
    label:
      'Directivos de organizaciones políticas, sindicales y asociaciones civi',
  },
  { value: '1150', label: 'Administrador' },
  { value: '1160', label: 'Gerente' },
  { value: '1170', label: 'Coordinador' },
  { value: '1180', label: 'Empresario' },
  { value: '1190', label: 'Supervisor' },
  {
    value: '2110',
    label: 'Físicos, astrónomos, meteorólogos, químicos, geólogos y geofísicos',
  },
  {
    value: '2120',
    label: 'Matemáticos, actuarios y estadísticos',
  },
  {
    value: '2130',
    label: 'Profesionales en ciencias biológicas',
  },
  { value: '2140', label: 'Ingenieros' },
  {
    value: '2150',
    label: 'Arquitectos, urbanistas, agrimensores y diseñadores',
  },
  { value: '2210', label: 'Médicos' },
  {
    value: '2220',
    label: 'Profesionales de enfermería',
  },
  {
    value: '2230',
    label: 'Profesionales de medicina tradicional y alternativa',
  },
  {
    value: '2240',
    label: 'Profesionales paramédicos con título universitario',
  },
  { value: '2250', label: 'Veterinarios' },
  { value: '2261', label: 'Odontólogos' },
  { value: '2262', label: 'Farmacéuticos' },
  {
    value: '2263',
    label: 'Profesionales de la salud, la higiene laboral y ambiental',
  },
  { value: '2264', label: 'Fisioterapeutas' },
  {
    value: '2265',
    label: 'Dietistas y nutricionistas',
  },
  {
    value: '2266',
    label: 'Audiólogos y logopedas',
  },
  { value: '2267', label: 'Optometristas' },
  {
    value: '2269',
    label: 'Profesionales de la salud n.e.o.g.',
  },
  { value: '2310', label: 'Profesores' },
  {
    value: '2320',
    label: 'Maestros de enseñanza primaria y maestros preescolares',
  },
  {
    value: '2330',
    label: 'Otros profesionales de la enseñanza',
  },
  { value: '2411', label: 'Contadores' },
  {
    value: '2412',
    label: 'Asesores financieros y de inversiones',
  },
  {
    value: '2413',
    label: 'Analistas financieros',
  },
  {
    value: '2420',
    label: 'Especialistas en organización de administración',
  },
  {
    value: '2430',
    label: 'Profesionales de las ventas, el mercadeo y las relaciones públicas',
  },
  {
    value: '2510',
    label: 'Desarrolladores y analistas de software y multimedia',
  },
  {
    value: '2520',
    label: 'Especialistas en bases de datos y en redes de computadores',
  },
  {
    value: '2610',
    label: 'Profesionales en derecho',
  },
  { value: '261A', label: 'Notario' },
  {
    value: '2620',
    label: 'Archiveros, bibliotecólogos, conservadores y afines',
  },
  { value: '2631', label: 'Economistas' },
  {
    value: '2632',
    label: 'Sociólogos, antropólogos y afines',
  },
  {
    value: '2633',
    label: 'Filósofos, historiadores y especialistas en ciencias políticas',
  },
  { value: '2634', label: 'Psicólogos' },
  {
    value: '2635',
    label: 'Profesionales del trabajo social',
  },
  {
    value: '2636',
    label: 'Profesionales religiosos',
  },
  {
    value: '2640',
    label: 'Autores, periodistas y lingüistas',
  },
  {
    value: '2651',
    label: 'Artistas de artes plásticas',
  },
  {
    value: '2652',
    label: 'Músicos, cantantes y compositores',
  },
  {
    value: '2653',
    label: 'Bailarines y coreógrafos',
  },
  {
    value: '2654',
    label: 'Directores de cine,  teatro y afines',
  },
  { value: '2655', label: 'Actores' },
  {
    value: '2656',
    label: 'Locutores de radio, televisión y otros medios de comunicación',
  },
  {
    value: '2659',
    label: 'Artistas creativos e interpretativos n.e.o.g.',
  },
  {
    value: '2900',
    label:
      'Otros trabajadores que desempeñan una ocupación afín a las comprendida',
  },
  {
    value: '3110',
    label: 'Técnicos en ciencias físicas y en ingeniería',
  },
  {
    value: '3120',
    label:
      'Supervisores en ingeneria de minas, industrias manufactureras y de la',
  },
  {
    value: '3130',
    label: 'Técnicos en control de procesos',
  },
  {
    value: '3140',
    label:
      'Técnicos y profesionales de nivel medio en ciencias biológicas y afine',
  },
  {
    value: '3150',
    label: 'Técnicos y controladores en navegación marítima y aeronáutica',
  },
  {
    value: '3210',
    label: 'Técnicos médicos y farmacéuticos',
  },
  {
    value: '3220',
    label: 'Profesionales de nivel medio de enfermería y partería',
  },
  {
    value: '3230',
    label: 'Profesionales de nivel medio de medicina tradicional y alternativa',
  },
  {
    value: '3240',
    label: 'Técnicos y asistentes veterinarios',
  },
  {
    value: '3251',
    label: 'Ayudantes de odontología',
  },
  {
    value: '3252',
    label: 'Técnico en registros médicos y documentación sanitaria',
  },
  {
    value: '3253',
    label: 'Trabajadores comunitarios de la salud',
  },
  {
    value: '3254',
    label: 'Asistente en optometría y óptica',
  },
  {
    value: '3255',
    label: 'Asistentes fisioterapeutas',
  },
  {
    value: '3256',
    label: 'Practicantes y asistentes médicos',
  },
  {
    value: '3257',
    label: 'Inspectores de la salud laboral, medioambiental y afines',
  },
  {
    value: '3258',
    label: 'Técnicos de atención de emergencia',
  },
  {
    value: '3259',
    label: 'Profesionales de la salud de nivel medio n.e.o.g.',
  },
  {
    value: '3311',
    label: 'Agentes de bolsa, cambio y otros servicios financieros',
  },
  {
    value: '3312',
    label: 'Oficiales de préstamos y créditos',
  },
  { value: '3313', label: 'Tenedores de libros' },
  {
    value: '3314',
    label:
      'Asistentes en servicios estadísticos, matemáticos,  contabilidad  y af',
  },
  { value: '3315', label: 'Tasadores' },
  {
    value: '331A',
    label: 'Remesadora De Dinero',
  },
  { value: '331B', label: 'Casa De Cambio' },
  {
    value: '3320',
    label: 'Agentes comerciales y corredores',
  },
  {
    value: '3331',
    label: 'Declarantes o gestores de aduana',
  },
  {
    value: '3332',
    label: 'Organizadores de conferencias y eventos',
  },
  {
    value: '3333',
    label: 'Agentes de empleo y contratistas de mano de obra',
  },
  {
    value: '3334',
    label: 'Agentes inmobiliarios',
  },
  {
    value: '3339',
    label: 'Agentes de servicios comerciales n.e.o.g.',
  },
  {
    value: '3340',
    label: 'Secretarios administrativos, especializados y afines',
  },
  {
    value: '3350',
    label:
      'Agentes de la administración pública para la aplicación de la ley y af',
  },
  {
    value: '3411',
    label:
      'Profesionales de nivel medio del derecho y servicios legales y afines',
  },
  {
    value: '3412',
    label: 'Trabajadores y asistentes sociales de nivel medio',
  },
  {
    value: '3413',
    label: 'Auxiliares laicos de las religiones',
  },
  {
    value: '3420',
    label: 'Entrenadores de deportes y aptitud física',
  },
  { value: '3431', label: 'Fotógrafos' },
  {
    value: '3432',
    label: 'Diseñadores y decoradores de interior',
  },
  {
    value: '3433',
    label: 'Técnicos en galerías de arte, museos y bibliotecas',
  },
  { value: '3434', label: 'Chefs' },
  {
    value: '3435',
    label:
      'Otros profesionales de nivel medio en actividades culturales y artísti',
  },
  {
    value: '3500',
    label: 'Técnicos de la tecnología de la información y las comunicaciones',
  },
  {
    value: '3900',
    label:
      'Otros trabajadores que desempeñan una ocupación afín a las comprendida',
  },
  { value: '4110', label: 'Secretarios' },
  {
    value: '4120',
    label: 'Operadores de máquinas de oficina',
  },
  {
    value: '4211',
    label: 'Cajeros de bancos y correos',
  },
  {
    value: '4212',
    label: 'Receptores de apuestas y afines',
  },
  {
    value: '4213',
    label: 'Empleados de casas de empeño y de préstamos',
  },
  {
    value: '4214',
    label: 'Cobradores de factura, deudas y afines',
  },
  {
    value: '4220',
    label: 'Empleados de servicios de información al cliente',
  },
  {
    value: '4310',
    label: 'Auxiliares contables y financieros',
  },
  {
    value: '4320',
    label: 'Empleados encargados del registro de materiales y de transportes',
  },
  {
    value: '4411',
    label: 'Empleados de bibliotecas',
  },
  {
    value: '4412',
    label: 'Empleados de servicios de correos',
  },
  {
    value: '4413',
    label:
      'Codificadores de datos, correctores de pruebas de imprenta y afines',
  },
  {
    value: '4414',
    label: 'Escribientes públicos y afines',
  },
  {
    value: '4415',
    label: 'Empleados de archivo y correspondencia',
  },
  {
    value: '4416',
    label: 'Empleados de gestión de recursos humanos',
  },
  {
    value: '4419',
    label: 'Personal de oficina  n.e.o.g.',
  },
  {
    value: '4900',
    label:
      'Otros trabajadores que desempeñan una ocupación afín a las comprendida',
  },
  {
    value: '5110',
    label: 'Personal al servicio directo de los pasajeros',
  },
  {
    value: '5120',
    label: 'Cocineros (excluye chefs y cocineros de comidas rápidas)',
  },
  { value: '5130', label: 'Meseros y saloneros' },
  {
    value: '5140',
    label: 'Peluqueros, especialistas en tratamientos de belleza y afines',
  },
  {
    value: '5150',
    label: 'Supervisores de mantenimiento y limpieza de edificios',
  },
  {
    value: '5160',
    label: 'Otros trabajadores de servicios personales',
  },
  {
    value: '5210',
    label: 'Cuidadores de niños y auxiliares de maestros',
  },
  {
    value: '5220',
    label: 'Trabajadores de los cuidados personales en servicios de salud',
  },
  { value: '5311', label: 'Bomberos' },
  { value: '5312', label: 'Policías' },
  {
    value: '5313',
    label: 'Custodios de prisión',
  },
  {
    value: '5314',
    label: 'Guardias de seguridad',
  },
  {
    value: '5319',
    label: 'Trabajadores de los servicios de protección y seguridad n.e.o.g.',
  },
  {
    value: '5410',
    label: 'Vendedores callejeros y de puestos de mercados',
  },
  {
    value: '5420',
    label:
      'Comerciantes de pequeños comercios y vendedores de tiendas y almacenes',
  },
  {
    value: '5430',
    label: 'Cajeros en comercios y expendedores de boletos',
  },
  { value: '5440', label: 'Otros vendedores' },
  {
    value: '5900',
    label:
      'Otros trabajadores que desempeñan una ocupación afín a las comprendida',
  },
  {
    value: '6110',
    label:
      'Productores de cultivos y cría de animales cuya producción se destina',
  },
  {
    value: '6200',
    label: 'Trabajadores forestales, pescadores y cazadores',
  },
  {
    value: '6300',
    label: 'Agricultores, criadores de animales y pescadores de subsistencia',
  },
  {
    value: '7100',
    label:
      'Trabajadores   en  obras  estructurales  de  la  construcción  y  acab',
  },
  {
    value: '7210',
    label:
      'Moldeadores,   soldadores,   chapisteros,   caldereros,   montadores',
  },
  {
    value: '7220',
    label: 'Herreros, herramentistas y afines',
  },
  {
    value: '7230',
    label: 'Mecánicos y reparadores de máquinas',
  },
  {
    value: '7300',
    label: 'Artesanos y operarios de las artes gráficas',
  },
  {
    value: '7411',
    label: 'Electricistas de obras y afines',
  },
  {
    value: '7412',
    label: 'Mecánicos y ajustadores electricistas',
  },
  {
    value: '7413',
    label: 'Instaladores y reparadores de líneas eléctricas',
  },
  {
    value: '7421',
    label: 'Mecánicos y reparadores en electrónica',
  },
  {
    value: '7422',
    label:
      'Instaladores y reparadores en tecnología de la información y las comun',
  },
  {
    value: '7429',
    label:
      'Trabajadores especializados en electricidad y la electrotecnología n.e',
  },
  {
    value: '7511',
    label: 'Matarifes y trabajadores de las industrias cárnicas y del pescado',
  },
  {
    value: '7512',
    label: 'Panaderos, pasteleros y confiteros',
  },
  {
    value: '7513',
    label: 'Trabajadores de la elaboración de productos lácteos',
  },
  {
    value: '7514',
    label:
      'Trabajadores en la conservación de frutas, legumbres, verduras y afine',
  },
  {
    value: '7515',
    label: 'Catadores y clasificadores de alimentos y bebidas',
  },
  {
    value: '7516',
    label: 'Preparadores y elaboradores de tabaco y sus productos',
  },
  {
    value: '7517',
    label: 'Trabajadores en la elaboración de alimentos n.e.o.g.',
  },
  {
    value: '7520',
    label: 'Trabajadores del tratamiento de la madera, ebanistas y afines',
  },
  {
    value: '7531',
    label: 'Sastres, modistos, peleteros y sombrereros',
  },
  {
    value: '7532',
    label: 'Patronistas y cortadores de tela y afines',
  },
  {
    value: '7533',
    label: 'Costureros, bordadores y afines',
  },
  {
    value: '7534',
    label: 'Tapiceros, colchoneros y afines',
  },
  {
    value: '7535',
    label: 'Curtidores y preparadores de pieles',
  },
  {
    value: '7536',
    label: 'Zapateros, talabarteros y afines',
  },
  { value: '7541', label: 'Buzos' },
  {
    value: '7542',
    label: 'Dinamiteros y pegadores',
  },
  {
    value: '7543',
    label:
      'Clasificadores y probadores de productos (excluye alimentos y bebidas)',
  },
  {
    value: '7544',
    label: 'Fumigadores y otros controladores de plagas y malas hierbas',
  },
  {
    value: '7549',
    label: 'Otros artesanos, operarios y trabajadores n.e.o.g.',
  },
  {
    value: '8100',
    label: 'Operadores de instalaciones fijas y máquinas',
  },
  { value: '8200', label: 'Ensambladores' },
  {
    value: '8300',
    label: 'Conductores de vehículos y operadores de equipos pesados móviles',
  },
  {
    value: '8900',
    label:
      'Otros trabajadores que desempeñan una ocupación afín a las comprendida',
  },
  {
    value: '9100',
    label: 'Limpiadores, lavanderos y planchadores',
  },
  {
    value: '9200',
    label: 'Peones agropecuarios, pesqueros y forestales',
  },
  {
    value: '9300',
    label:
      'Obreros de la minería, la construcción, la industria manufacturera y e',
  },
  {
    value: '9400',
    label: 'Ayudantes en la preparación de alimentos para el consumo inmediato',
  },
  {
    value: '9500',
    label: 'Trabajadores ambulantes de servicios y vendedores ambulantes',
  },
  {
    value: '9600',
    label: 'Recolectores de desechos y otras ocupaciones elementales',
  },
  {
    value: '9900',
    label:
      'Otros trabajadores que desempeñan una ocupación afín a las comprendida',
  },
];

export const OCCUPATION_OPTIONS = [
  { value: 'Empleado', label: 'Empleado' },
  { value: 'Independiente', label: 'Independiente' },
  { value: 'Empresario', label: 'Empresario' },
  { value: 'Inversionista', label: 'Inversionista' },
  { value: 'Jubilado/Pensionado', label: 'Jubilado/Pensionado' },
  { value: 'Desempleado', label: 'Desempleado' },
];

export const YES_NO_OPTIONS = () =>
  buildYesNoOptions(i18nInstance.t.bind(i18nInstance));

export const COUNTRY_OPTIONS = [
  { value: 'AF', label: 'Afganistán', meta: '(+93) - AF', dialCode: '+93' },
  {
    value: 'SA',
    label: 'Arabia Saudita',
    meta: '(+966) - SA',
    dialCode: '+966',
  },
  { value: 'DZ', label: 'Argelia', meta: '(+213) - DZ', dialCode: '+213' },
  { value: 'AD', label: 'Andorra', meta: '(+376) - AD', dialCode: '+376' },
  { value: 'AO', label: 'Angola', meta: '(+244) - AO', dialCode: '+244' },
  {
    value: 'AG',
    label: 'Antigua y Barbuda',
    meta: '(+1-268) - AG',
    dialCode: '+1-268',
  },
  { value: 'AR', label: 'Argentina', meta: '(+54) - AR', dialCode: '+54' },
  { value: 'AU', label: 'Australia', meta: '(+61) - AU', dialCode: '+61' },
  { value: 'AT', label: 'Austria', meta: '(+43) - AT', dialCode: '+43' },
  { value: 'BS', label: 'Bahamas', meta: '(+1-242) - BS', dialCode: '+1-242' },
  { value: 'BD', label: 'Bangladés', meta: '(+880) - BD', dialCode: '+880' },
  { value: 'BH', label: 'Baréin', meta: '(+973) - BH', dialCode: '+973' },
  { value: 'BB', label: 'Barbados', meta: '(+1-246) - BB', dialCode: '+1-246' },
  { value: 'BE', label: 'Bélgica', meta: '(+32) - BE', dialCode: '+32' },
  { value: 'BZ', label: 'Belice', meta: '(+501) - BZ', dialCode: '+501' },
  { value: 'BJ', label: 'Benín', meta: '(+229) - BJ', dialCode: '+229' },
  { value: 'MM', label: 'Birmania', meta: '(+95) - MM', dialCode: '+95' },
  { value: 'BO', label: 'Bolivia', meta: '(+591) - BO', dialCode: '+591' },
  { value: 'BW', label: 'Botsuana', meta: '(+267) - BW', dialCode: '+267' },
  { value: 'BN', label: 'Brunéi', meta: '(+673) - BN', dialCode: '+673' },
  { value: 'BF', label: 'Burkina Faso', meta: '(+226) - BF', dialCode: '+226' },
  { value: 'BI', label: 'Burundi', meta: '(+257) - BI', dialCode: '+257' },
  { value: 'BT', label: 'Bután', meta: '(+975) - BT', dialCode: '+975' },
  { value: 'CV', label: 'Cabo Verde', meta: '(+238) - CV', dialCode: '+238' },
  { value: 'KH', label: 'Camboya', meta: '(+855) - KH', dialCode: '+855' },
  { value: 'CM', label: 'Camerún', meta: '(+237) - CM', dialCode: '+237' },
  { value: 'CA', label: 'Canadá', meta: '(+1) - CA', dialCode: '+1' },
  { value: 'QA', label: 'Catar', meta: '(+974) - QA', dialCode: '+974' },
  { value: 'TD', label: 'Chad', meta: '(+235) - TD', dialCode: '+235' },
  { value: 'CL', label: 'Chile', meta: '(+56) - CL', dialCode: '+56' },
  { value: 'CN', label: 'China', meta: '(+86) - CN', dialCode: '+86' },
  { value: 'CY', label: 'Chipre', meta: '(+357) - CY', dialCode: '+357' },
  { value: 'KM', label: 'Comoras', meta: '(+269) - KM', dialCode: '+269' },
  { value: 'KR', label: 'Corea del Sur', meta: '(+82) - KR', dialCode: '+82' },
  {
    value: 'CI',
    label: 'Costa de Marfil',
    meta: '(+225) - CI',
    dialCode: '+225',
  },
  { value: 'CR', label: 'Costa Rica', meta: '(+506) - CR', dialCode: '+506' },
  { value: 'CU', label: 'Cuba', meta: '(+53) - CU', dialCode: '+53' },
  { value: 'DK', label: 'Dinamarca', meta: '(+45) - DK', dialCode: '+45' },
  { value: 'DM', label: 'Dominica', meta: '(+1-767) - DM', dialCode: '+1-767' },
  { value: 'EC', label: 'Ecuador', meta: '(+593) - EC', dialCode: '+593' },
  { value: 'EG', label: 'Egipto', meta: '(+20) - EG', dialCode: '+20' },
  { value: 'SV', label: 'El Salvador', meta: '(+503) - SV', dialCode: '+503' },
  {
    value: 'AE',
    label: 'Emiratos Árabes Unidos',
    meta: '(+971) - AE',
    dialCode: '+971',
  },
  { value: 'ER', label: 'Eritrea', meta: '(+291) - ER', dialCode: '+291' },
  { value: 'ES', label: 'España', meta: '(+34) - ES', dialCode: '+34' },
  { value: 'US', label: 'Estados Unidos', meta: '(+1) - US', dialCode: '+1' },
  { value: 'SZ', label: 'Esuatini', meta: '(+268) - SZ', dialCode: '+268' },
  { value: 'ET', label: 'Etiopía', meta: '(+251) - ET', dialCode: '+251' },
  { value: 'PH', label: 'Filipinas', meta: '(+63) - PH', dialCode: '+63' },
  { value: 'FI', label: 'Finlandia', meta: '(+358) - FI', dialCode: '+358' },
  { value: 'FJ', label: 'Fiyi', meta: '(+679) - FJ', dialCode: '+679' },
  { value: 'FR', label: 'Francia', meta: '(+33) - FR', dialCode: '+33' },
  { value: 'GA', label: 'Gabón', meta: '(+241) - GA', dialCode: '+241' },
  { value: 'GM', label: 'Gambia', meta: '(+220) - GM', dialCode: '+220' },
  { value: 'GH', label: 'Ghana', meta: '(+233) - GH', dialCode: '+233' },
  { value: 'GD', label: 'Granada', meta: '(+1-473) - GD', dialCode: '+1-473' },
  { value: 'GR', label: 'Grecia', meta: '(+30) - GR', dialCode: '+30' },
  { value: 'GT', label: 'Guatemala', meta: '(+502) - GT', dialCode: '+502' },
  { value: 'GN', label: 'Guinea', meta: '(+224) - GN', dialCode: '+224' },
  { value: 'GW', label: 'Guinea-Bisáu', meta: '(+245) - GW', dialCode: '+245' },
  {
    value: 'GQ',
    label: 'Guinea Ecuatorial',
    meta: '(+240) - GQ',
    dialCode: '+240',
  },
  { value: 'GY', label: 'Guyana', meta: '(+592) - GY', dialCode: '+592' },
  { value: 'HT', label: 'Haití', meta: '(+509) - HT', dialCode: '+509' },
  { value: 'HN', label: 'Honduras', meta: '(+504) - HN', dialCode: '+504' },
  { value: 'IN', label: 'India', meta: '(+91) - IN', dialCode: '+91' },
  { value: 'ID', label: 'Indonesia', meta: '(+62) - ID', dialCode: '+62' },
  { value: 'IQ', label: 'Irak', meta: '(+964) - IQ', dialCode: '+964' },
  { value: 'IR', label: 'Irán', meta: '(+98) - IR', dialCode: '+98' },
  { value: 'IE', label: 'Irlanda', meta: '(+353) - IE', dialCode: '+353' },
  { value: 'IS', label: 'Islandia', meta: '(+354) - IS', dialCode: '+354' },
  { value: 'IL', label: 'Israel', meta: '(+972) - IL', dialCode: '+972' },
  { value: 'IT', label: 'Italia', meta: '(+39) - IT', dialCode: '+39' },
  { value: 'JM', label: 'Jamaica', meta: '(+1876) - JM', dialCode: '+1876' },
  { value: 'JP', label: 'Japón', meta: '(+81) - JP', dialCode: '+81' },
  { value: 'JO', label: 'Jordania', meta: '(+962) - JO', dialCode: '+962' },
  { value: 'KE', label: 'Kenia', meta: '(+254) - KE', dialCode: '+254' },
  { value: 'KG', label: 'Kirguistán', meta: '(+996) - KG', dialCode: '+996' },
  { value: 'KI', label: 'Kiribati', meta: '(+686) - KI', dialCode: '+686' },
  { value: 'KW', label: 'Kuwait', meta: '(+965) - KW', dialCode: '+965' },
  { value: 'LA', label: 'Laos', meta: '(+856) - LA', dialCode: '+856' },
  { value: 'LS', label: 'Lesoto', meta: '(+266) - LS', dialCode: '+266' },
  { value: 'LB', label: 'Líbano', meta: '(+961) - LB', dialCode: '+961' },
  { value: 'LR', label: 'Liberia', meta: '(+231) - LR', dialCode: '+231' },
  { value: 'LY', label: 'Libia', meta: '(+218) - LY', dialCode: '+218' },
  {
    value: 'LI',
    label: 'Liechtenstein',
    meta: '(+423) - LI',
    dialCode: '+423',
  },
  { value: 'LU', label: 'Luxemburgo', meta: '(+352) - LU', dialCode: '+352' },
  { value: 'MG', label: 'Madagascar', meta: '(+261) - MG', dialCode: '+261' },
  { value: 'MY', label: 'Malasia', meta: '(+60) - MY', dialCode: '+60' },
  { value: 'MW', label: 'Malaui', meta: '(+265) - MW', dialCode: '+265' },
  { value: 'MV', label: 'Maldivas', meta: '(+960) - MV', dialCode: '+960' },
  { value: 'ML', label: 'Malí', meta: '(+223) - ML', dialCode: '+223' },
  { value: 'MT', label: 'Malta', meta: '(+356) - MT', dialCode: '+356' },
  { value: 'MA', label: 'Marruecos', meta: '(+212) - MA', dialCode: '+212' },
  { value: 'MH', label: 'Marshall', meta: '(+692) - MH', dialCode: '+692' },
  { value: 'MU', label: 'Mauricio', meta: '(+230) - MU', dialCode: '+230' },
  { value: 'MR', label: 'Mauritania', meta: '(+222) - MR', dialCode: '+222' },
  { value: 'MX', label: 'México', meta: '(+52) - MX', dialCode: '+52' },
  { value: 'FM', label: 'Micronesia', meta: '(+691) - FM', dialCode: '+691' },
  { value: 'MC', label: 'Mónaco', meta: '(+377) - MC', dialCode: '+377' },
  { value: 'MN', label: 'Mongolia', meta: '(+976) - MN', dialCode: '+976' },
  { value: 'MZ', label: 'Mozambique', meta: '(+258) - MZ', dialCode: '+258' },
  { value: 'NA', label: 'Namibia', meta: '(+264) - NA', dialCode: '+264' },
  { value: 'NR', label: 'Nauru', meta: '(+677) - NR', dialCode: '+677' },
  { value: 'NP', label: 'Nepal', meta: '(+977) - NP', dialCode: '+977' },
  { value: 'NI', label: 'Nicaragua', meta: '(+505) - NI', dialCode: '+505' },
  { value: 'NE', label: 'Níger', meta: '(+227) - NE', dialCode: '+227' },
  { value: 'NG', label: 'Nigeria', meta: '(+234) - NG', dialCode: '+234' },
  { value: 'NO', label: 'Noruega', meta: '(+47) - NO', dialCode: '+47' },
  { value: 'NZ', label: 'Nueva Zelanda', meta: '(+64) - NZ', dialCode: '+64' },
  { value: 'OM', label: 'Omán', meta: '(+968) - OM', dialCode: '+968' },
  { value: 'NL', label: 'Países Bajos', meta: '(+31) - NL', dialCode: '+31' },
  { value: 'PK', label: 'Pakistán', meta: '(+92) - PK', dialCode: '+92' },
  { value: 'PW', label: 'Palaos', meta: '(+680) - PW', dialCode: '+680' },
  { value: 'PS', label: 'Palestina', meta: '(+970) - PS', dialCode: '+970' },
  { value: 'PA', label: 'Panamá', meta: '(+507) - PA', dialCode: '+507' },
  {
    value: 'PG',
    label: 'Papúa Nueva Guinea',
    meta: '(+675) - PG',
    dialCode: '+675',
  },
  { value: 'PY', label: 'Paraguay', meta: '(+595) - PY', dialCode: '+595' },
  { value: 'PE', label: 'Perú', meta: '(+51) - PE', dialCode: '+51' },
  { value: 'PT', label: 'Portugal', meta: '(+351) - PT', dialCode: '+351' },
  { value: 'GB', label: 'Reino Unido', meta: '(+44) - GB', dialCode: '+44' },
  {
    value: 'CF',
    label: 'República Centroafricana',
    meta: '(+236) - CF',
    dialCode: '+236',
  },
  {
    value: 'CG',
    label: 'República del Congo',
    meta: '(+242) - CG',
    dialCode: '+242',
  },
  {
    value: 'CD',
    label: 'República Democrática del Congo',
    meta: '(+243) - CD',
    dialCode: '+243',
  },
  {
    value: 'DO',
    label: 'República Dominicana',
    meta: '(+1809, +1829, +1849) - DO',
    dialCode: '+1809',
  },
  { value: 'RW', label: 'Ruanda', meta: '(+250) - RW', dialCode: '+250' },
  { value: 'WS', label: 'Samoa', meta: '(+685) - WS', dialCode: '+685' },
  {
    value: 'KN',
    label: 'San Cristóbal y Nieves',
    meta: '(+1869) - KN',
    dialCode: '+1869',
  },
  { value: 'SM', label: 'San Marino', meta: '(+378) - SM', dialCode: '+378' },
  {
    value: 'VC',
    label: 'San Vicente y las Granadinas',
    meta: '(+1784) - VC',
    dialCode: '+1784',
  },
  {
    value: 'LC',
    label: 'Santa Lucía',
    meta: '(+1758) - LC',
    dialCode: '+1758',
  },
  {
    value: 'ST',
    label: 'Santo Tomé y Príncipe',
    meta: '(+239) - ST',
    dialCode: '+239',
  },
  { value: 'SN', label: 'Senegal', meta: '(+221) - SN', dialCode: '+221' },
  { value: 'SC', label: 'Seychelles', meta: '(+248) - SC', dialCode: '+248' },
  { value: 'SL', label: 'Sierra Leona', meta: '(+232) - SL', dialCode: '+232' },
  { value: 'SG', label: 'Singapur', meta: '(+65) - SG', dialCode: '+65' },
  { value: 'SY', label: 'Siria', meta: '(+963) - SY', dialCode: '+963' },
  { value: 'SO', label: 'Somalia', meta: '(+252) - SO', dialCode: '+252' },
  { value: 'LK', label: 'Sri Lanka', meta: '(+94) - LK', dialCode: '+94' },
  { value: 'ZA', label: 'Sudáfrica', meta: '(+27) - ZA', dialCode: '+27' },
  { value: 'SD', label: 'Sudán', meta: '(+249) - SD', dialCode: '+249' },
  {
    value: 'SS',
    label: 'Sudán del Sur',
    meta: '(+211) - SS',
    dialCode: '+211',
  },
  { value: 'SE', label: 'Suecia', meta: '(+46) - SE', dialCode: '+46' },
  { value: 'CH', label: 'Suiza', meta: '(+41) - CH', dialCode: '+41' },
  { value: 'SR', label: 'Surinam', meta: '(+597) - SR', dialCode: '+597' },
  { value: 'TH', label: 'Tailandia', meta: '(+66) - TH', dialCode: '+66' },
  { value: 'TZ', label: 'Tanzania', meta: '(+255) - TZ', dialCode: '+255' },
  { value: 'TJ', label: 'Tayikistán', meta: '(+993) - TJ', dialCode: '+993' },
  {
    value: 'TL',
    label: 'Timor Oriental',
    meta: '(+670) - TL',
    dialCode: '+670',
  },
  { value: 'TG', label: 'Togo', meta: '(+228) - TG', dialCode: '+228' },
  { value: 'TO', label: 'Tonga', meta: '(+676) - TO', dialCode: '+676' },
  {
    value: 'TT',
    label: 'Trinidad y Tobago',
    meta: '(+1868) - TT',
    dialCode: '+1868',
  },
  { value: 'TN', label: 'Túnez', meta: '(+216) - TN', dialCode: '+216' },
  { value: 'TM', label: 'Turkmenistán', meta: '(+993) - TM', dialCode: '+993' },
  { value: 'TR', label: 'Turquía', meta: '(+90) - TR', dialCode: '+90' },
  { value: 'TV', label: 'Tuvalu', meta: '(+688) - TV', dialCode: '+688' },
  { value: 'UG', label: 'Uganda', meta: '(+256) - UG', dialCode: '+256' },
  { value: 'UY', label: 'Uruguay', meta: '(+598) - UY', dialCode: '+598' },
  { value: 'UZ', label: 'Uzbekistán', meta: '(+998) - UZ', dialCode: '+998' },
  { value: 'VU', label: 'Vanuatu', meta: '(+678) - VU', dialCode: '+678' },
  {
    value: 'VA',
    label: 'Vaticano',
    meta: '(+379, +39) - VA',
    dialCode: '+379',
  },
  { value: 'VN', label: 'Vietnam', meta: '(+84) - VN', dialCode: '+84' },
  { value: 'YE', label: 'Yemen', meta: '(+967) - YE', dialCode: '+967' },
  { value: 'DJ', label: 'Yibuti', meta: '(+253) - DJ', dialCode: '+253' },
  { value: 'ZM', label: 'Zambia', meta: '(+260) - ZM', dialCode: '+260' },
  { value: 'ZW', label: 'Zimbabue', meta: '(+263) - ZW', dialCode: '+263' },
];

export const REFERENCE_TYPE_OPTIONS = [
  {
    value: 'familiar',
    labelKey: 'references.form.type.options.family',
    fallback: 'Familiar',
  },
  {
    value: 'personal',
    labelKey: 'references.form.type.options.personal',
    fallback: 'Personal',
  },
];
